jQuery(function ($) {

    // Enable Magnific Popup for gallery
    $('.gallery').each(function() {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true,
                tCounter: '%curr% / %total%'
            },
            image: {
                titleSrc: 'title'
                // this tells the script which attribute has your caption
            }
        });
    });

});

jQuery('document').ready(function($){
  $('.nav-search').on('click', function(){
    $(".site-header .searchform").slideToggle({
      duration: 250,
      start: function(){
        $(this).css('display','flex');
      }
    });
  });

  $('.close-search').on('click', function(){
    $(".site-header .searchform").slideToggle();
  });

  // function checkWidth() {
  //   var wwidth = $( window ).width();

  //   if(wwidth > 980) {
  //     $(".site-header .searchform").css('display','block');
  //   }
  //   else {
  //     $(".site-header .searchform").css('display','none');
  //   }
  // }
  //   $(window).resize(checkWidth);

  var header = $('.site-header');
  //var height = header.height();
  $(window).scroll(function() {
  var scroll = $(window).scrollTop();
      if (scroll >= 500) {
          header.addClass('fixed');
          $('.site').css('padding-top', '191.6px');
      } else {
        header.removeClass('fixed');
        $('.site').css('padding-top', '0');
      }
  });
  // $('.categories .children').parent().addClass('parent');
  // $('.categories .children').parent().prepend('<div class="cat-icon"><svg width="28" height="28" viewBox="0 0 28 28"><path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#000723"/></svg></div>');

  // $('.cat-icon').on('click', function(){
  //   $(this).toggleClass('rotateicon');
  //   $(this).nextAll('.children').slideToggle();
  //   // $(this).find('svg path').attr('d');
  // });

  // $('.current-cat .cat-icon').addClass('rotateicon');
  // $('.current-cat-parent .cat-icon').addClass('rotateicon');

  // function checkWidth() {
  //   var wwidth = $( window ).width();

  //   if(wwidth < 768 ) {
  //     $( ".entry-summary .woocommerce-breadcrumb" ).css("display", "none");
  //     $( ".entry-summary .product_title" ).css("display", "none");
  //     $( ".entry-summary .valmistajalogo" ).css("display", "none");
  //   }
  //   else {
  //     $( ".entry-summary .woocommerce-breadcrumb" ).css("display", "block");
  //     $( ".entry-summary .product_title" ).css("display", "block");
  //     $( ".entry-summary .valmistajalogo" ).css("display", "block");
  //   }

  //   if( wwidth >= 768) {
  //     $( ".mobile-product").css("display", "none");
  //   }
  //   else {
  //     $( ".mobile-product").css("display", "block");
  //   }
  // }
  // Execute on load
  // checkWidth();
  // $(window).resize(checkWidth);

  $('.close-cart, .header-cart-icon, .sidecartoverlay').on('click', function(e){
    e.preventDefault();
    $(".sidecart").toggle('fast');
    $(".sidecartoverlay").toggle();
  });

  $('body').on('added_to_cart',function(e){
    e.preventDefault();
    $(".sidecart").toggle('fast');
    $(".sidecartoverlay").toggle();
  });

  $('body').on('click', '.wc-checkout-method-icon', function(){
    $([document.documentElement, document.body]).animate({
      scrollTop: ($("#order_review").offset().top - 100)
  }, 1000);
  });
});

jQuery('document').ready(function($){
  $('.readmore-product').on('click', function(){
    event.preventDefault();
    $(".readmore-the-content").toggle('fast');
  });
});
